import React from "react";
import {
  Button,
  Center,
  Container,
  Divider,
  HStack,
  Icon,
  Link,
  LinkBox,
  LinkOverlay,
  Text,
  useBoolean,
} from "@chakra-ui/react";
import FanadiseLogo from "components/FanadiseLogo";
import useTranslate from "hooks/useTranslate";
import OpenseaIcon from "components/OpenseaIcon";
import DiscordIcon from "components/DiscordIcon";
import TwitterIcon from "components/TwitterIcon";
import Panel from "components/Panel";
import IncentivesPopup from "components/IncentivesPopup";
import ContractsPopup from "components/ContractsPopup";
import { learnMoreUrl, v2OpenSeaUrl } from "config";

const Footer: React.FC = () => {
  const translate = useTranslate();
  const [isContractsPopupOpen, setIsContractsPopupOpen] = useBoolean(false);
  const [isIncentivesPopupOpen, setIsIncentivesPopupOpen] = useBoolean(false);

  return (
    <>
      <Panel as="footer" mt="auto" bg="dark.900" px="0" borderRadius="none">
        <Container>
          <HStack justify="space-between">
            <HStack spacing="5">
              <Link
                href={v2OpenSeaUrl}
                target="_blank"
                display="flex"
                alignItems="center"
              >
                <Icon as={OpenseaIcon} w="7" h="auto" />
              </Link>

              <Link
                href="//discord.gg/fancybearsmetaverse"
                target="_blank"
                display="flex"
                alignItems="center"
              >
                <Icon as={DiscordIcon} w="7" h="auto" />
              </Link>

              <Link
                href="//twitter.com/FancyBearsMeta"
                target="_blank"
                display="flex"
                alignItems="center"
              >
                <Icon as={TwitterIcon} w="7" h="auto" />
              </Link>
            </HStack>

            <HStack justify="space-between" spacing="4">
              <Link href={learnMoreUrl} target="_blank">
                <Button as="span" variant="link" fontSize="sm">
                  {translate("footer:learnMore")}
                </Button>
              </Link>

              <Button
                variant="link"
                fontSize="sm"
                onClick={setIsContractsPopupOpen.on}
              >
                {translate("common:contracts")}
              </Button>

              <Button
                variant="link"
                fontSize="sm"
                onClick={setIsIncentivesPopupOpen.on}
              >
                {translate("common:incentives")}
              </Button>
            </HStack>
          </HStack>

          <Divider my="2.5" />

          <LinkBox as={Center}>
            <Text fontSize="sm" fontWeight="semibold">
              {translate("footer:powered")}
            </Text>
            <LinkOverlay href="//fanadise.com" target="_blank">
              <FanadiseLogo width="115" />
            </LinkOverlay>
          </LinkBox>
        </Container>
      </Panel>

      {isContractsPopupOpen && (
        <ContractsPopup isOpen onClose={() => setIsContractsPopupOpen.off()} />
      )}

      {isIncentivesPopupOpen && (
        <IncentivesPopup
          isOpen
          onClose={() => setIsIncentivesPopupOpen.off()}
        />
      )}
    </>
  );
};

export default Footer;
